import { MenuItem, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledSelect from 'src/components/common/styled/StyledSelect';
import { useMetricSelect } from 'src/components/common/metrics/useMetricSelect';
import { ServiceType } from 'src/enums/ServiceType';
import { OrionTheme } from 'src/components/theme/orion/Theme';

export const MetricSelect = (): JSX.Element => {
  const { value, onSelect } = useMetricSelect();
  const isMobile = useMediaQuery(OrionTheme.breakpoints.down('sm'));
  const { t } = useTranslation([ServiceType.GOOGLE]);

  return (
    <StyledSelect
      data-testid="metricSelect"
      value={value}
      onChange={onSelect}
      sx={{ width: isMobile ? '100%' : '296px' }}
      size="small"
    >
      <MenuItem value="overallScore">{t('tracker.overall_score')}</MenuItem>
      <MenuItem value="totalActions">{t('tracker.account_activity')}</MenuItem>
    </StyledSelect>
  );
};
